module.exports = "/lucky-balls/img/drum/drum_loop_035.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_035.png
// module id = 1050
// module chunks = 0